import React from "react";
import NumberFormat from 'react-number-format';


export function EnergiaReativaHtml({
    ...props
}) {

    return (
        <>
            <NumberFormat thousandSeparator={true} suffix={' kVAr'}
                displayType={'text'}
                decimalSeparator=","
                          decimalScale={2}
                thousandSeparator="."
                value={props.value}
            />
        </>
    );
}
